<template>
	<div>
		<div class="user-choose">
			<div
			 class="choose-detail-item"
			 v-for="(item, index) in multSelectArray"
			 :key="index"
			 @click="chooseItem(index)"
			>
				<div class="choose-detail">
					<span :class="{'title-tip': item.hasSelected}">{{item.name}}</span>
					<span
					 class="select-tip"
					 :class="{'title-tip': !item.hasSelected, 'selected-text': item.hasSelected, 'error': item.isError && !item.hasSelected}"
					>{{item.selectedText}}</span>
				</div>
			</div>
		</div>
		<popup v-model="showBox">
			<div class="popup-box">
				<div class="popup-top">
					<div class="user-choose">
						<div
						 class="choose-detail-item"
						 v-for="(item, index) in multSelectArray"
						 :key="index"
						 :class="{active: selectedItem === index}"
						 @click="chooseItem(index)"
						>
							<div class="choose-detail">
								<span :class="{'title-tip': item.hasSelected}">{{item.name}}</span>
								<span :class="{'title-tip': !item.hasSelected, 'selected-text': item.hasSelected}">{{item.selectedText}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="popup-title">
					<span class="title">{{multSelectArray[selectedItem].title}}</span>
					<span
					 class="btn"
					 @click="nextSelect(selectedItem)"
					>{{btnText}}</span>
				</div>
				<select-scroll
				 :dataList="item.list"
				 :selectedIndex="item.selectedIndex"
				 :show="showBox && index === selectedItem"
				 v-for="(item, index) in multSelectArray"
				 :key="index"
				 @scrollEnd="scrollEnd"
				></select-scroll>
			</div>
		</popup>
	</div>
</template>
<script>
import { Popup } from "@58fe/v5";
import selectScroll from "../../common/selectScroll";
import config from "../../../util/config";
import * as types from "../../../store/mutation-types";
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			showBox: false,
			selectedItem: 0,
			hasSelectedNum: 0,
			btnText: "确定",
			multSelectArray: [
				{
					key: "birthday",
					name: "出生年份",
					title: "请选择您的出生年份",
					list: ["", ""].concat(config.birthdayList).concat(["", ""]),
					selectedIndex: 37, // 默认23岁（1995年）
					selectedText: "请选择",
					hasSelected: false,
					isError: false // 为空时错误标注
				},
				{
					key: "education",
					name: "最高学历",
					title: "请选择您的最高学历",
					list: ["", ""]
						.concat(config.educationList)
						.concat(["", ""]),
					selectedIndex: 3, // 默认大专
					selectedText: "请选择",
					hasSelected: false,
					isError: false
				},
				{
					key: "workyears",
					name: "工作时间",
					title: "请选择您参加工作的时间",
					list: ["", ""]
						.concat(config.experienceList)
						.concat(["", ""]),
					selectedIndex: 4, // 默认选择3-5年
					selectedText: "请选择",
					hasSelected: false,
					isError: false
				}
			]
		};
	},
	computed: {
		...mapGetters([
			"birthday",
			"education",
			"workyears",
			"pagetypeLog",
			"educations",
			"pagefrom"
		])
	},
	watch: {
		// 默认渲染上一份简历信息
		birthday(val) {
			this.setBirthday(val);
		},
		education(val) {
			this.setEducation(val);
		},
		workyears(val) {
			this.setWorkyears(val);
		},

		// 深度监控
		multSelectArray: {
			handler(curVal, oldVal) {
				if (this.hasSelectedNum < 3) {
					let num = 0;
					for (let item of curVal) {
						if (item.hasSelected) {
							num++;
						}
					}
					this.hasSelectedNum = num;
				}
				this.setEduState();
			},
			deep: true
		},
		hasSelectedNum(val) {
			if (val === 3) {
				this.btnText = "完成";
			}
		}
	},
	created() {
		if (this.pagefrom === 'fromCQXZ' && this.multSelectArray.length > 2) {
			this.multSelectArray[2].selectedIndex = 1;  // 重庆校招默认选应届生
		}
		// 若有值初始化
		if (this.birthday) {
			this.setBirthday(this.birthday);
		}
		if (this.education) {
			this.setEducation(this.education);
		}
		if (this.workyears) {
			this.setWorkyears(this.workyears);
		}
		this.setEduState();
	},
	components: {
		Popup,
		selectScroll
	},
	methods: {
		/**
		 * 设置教育经历必填状态
		 * !【大专及以上 + 校招 + 应届生】状态置为 true
		 *  【大专及以上 + 校招 + 应届生 + educations.length > 0】状态置为 true
		 */
		setEduState() {
			let eduflag =
				this.education > 3 &&
				(this.pagefrom === "fromXZ" || this.pagefrom === "fromCQXZ") &&
				this.workyears === 5;
			this.$store.commit(types.CHECK_BASICINFO, {
				key: "educations",
				value: JSON.stringify(this.educations),
				state: !eduflag || (eduflag && this.educations.length > 0)
			});
		},
		// 默认渲染上一份简历信息
		setBirthday(val) {
			let defaultText = val.split("-")[0] + "年",
				birthdaySelect = this.multSelectArray[0],
				index = config.birthdayList.indexOf(defaultText);

			this.$set(birthdaySelect, "selectedIndex", index);
			this.$set(birthdaySelect, "selectedText", defaultText);
			this.$set(birthdaySelect, "hasSelected", true);
		},
		setEducation(val) {
			let index = val - 1, // 教育经历从1开始
				educationSelect = this.multSelectArray[1],
				defaultText = config.educationList[index];

			this.$set(educationSelect, "selectedIndex", index);
			this.$set(educationSelect, "selectedText", defaultText);
			this.$set(educationSelect, "hasSelected", true);
		},
		setWorkyears(val) {
			let index = config.experienceArray.indexOf(val),
				defaultText = config.experienceList[index],
				experienceSelect = this.multSelectArray[2];

			this.$set(experienceSelect, "selectedIndex", index);
			this.$set(experienceSelect, "selectedText", defaultText);
			this.$set(experienceSelect, "hasSelected", true);
		},
		// end

		hidePopup() {
			this.showBox = false;
		},
		showPopup() {
			this.showBox = true;
		},
		chooseItem(index) {
			this.selectedItem = index;
			this.scrollEnd(this.multSelectArray[index].selectedIndex); // 初始化选择

			if (!this.showBox) {
				this.showBox = true;
			}

			this.clickLog(index, "click");
		},
		nextSelect(selectedItem) {
			// 已全部选完
			if (this.hasSelectedNum === 3) {
				this.showBox = false;
			} else {
				let nextNoSelect = selectedItem + 1;
				if (nextNoSelect > 2) {
					// 没有全选完，但选到了最后面一个，跳转到未选择项
					nextNoSelect = 0;
				}

				// 如果该项已经选择，则进行递归
				if (this.multSelectArray[nextNoSelect].hasSelected) {
					this.nextSelect(nextNoSelect);
				} else {
					this.chooseItem(nextNoSelect);
				}
			}
		},
		scrollEnd(index) {
			let selectedIndex = index + 2, // 实际选择项
				selectedOption = this.multSelectArray[this.selectedItem], // 当前选择的item
				selectedValue = ""; // 选择项的值(默认为对应的index)

			this.$set(
				selectedOption,
				"selectedText",
				selectedOption.list[selectedIndex]
			); // 更新选择项的text
			this.$set(selectedOption, "selectedIndex", index); // 更新选择项的index
			this.$set(selectedOption, "hasSelected", true); // 更新选择项的状态

			// 如果是工作经验或出生年份，提交的字段值进行转换
			switch (selectedOption.key) {
				case "birthday":
					let birthdayText = config.birthdayList[index];
					selectedValue =
						birthdayText.substring(0, birthdayText.length - 1) +
						"-01-01";
					break;
				case "workyears":
					selectedValue = config.experienceArray[index];
					break;
				case "education": // 教育经历从1开始
					selectedValue = index + 1;
					break;
			}

			//  检查是否已填写完整
			this.$store.commit(types.CHECK_BASICINFO, {
				key: selectedOption.key,
				value: selectedValue,
				state: true
			});
		},
		checkNull(item) {
			// 没有填写项对应的index
			let index = ["birthday", "education", "workyears"].indexOf(item);
			this.$set(this.multSelectArray[index], "isError", true); // 置为error状态

			this.clickLog(index, "error");
		},
		clickLog(index, type) {
			if (type === "click") {
				switch (index) {
					case 0:
						window.clickLog &&
							window.clickLog(
								"from=jl_birthdayclick" + this.pagetypeLog
							);
						break;
					case 1:
						window.clickLog &&
							window.clickLog(
								"from=jl_degreeclick" + this.pagetypeLog
							);
						break;
					case 2:
						window.clickLog &&
							window.clickLog(
								"from=jl_workyearclick" + this.pagetypeLog
							);
						break;
				}
			} else if (type === "error") {
				switch (index) {
					case 0:
						window.clickLog &&
							window.clickLog(
								"from=jl_birthdaymiss" + this.pagetypeLog
							);
						break;
					case 1:
						window.clickLog &&
							window.clickLog(
								"from=jl_degreemiss" + this.pagetypeLog
							);
						break;
					case 2:
						window.clickLog &&
							window.clickLog(
								"from=jl_workyearmiss" + this.pagetypeLog
							);
						break;
				}
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../../assets/style/public.scss";
.user-choose {
	font-size: px2rem(38px);
	color: #999;
	height: px2rem(174px);
	display: -webkit-flex; /* 新版本语法: Chrome 21+ */
	display: -moz-box; /* 老版本语法: Firefox (buggy) */
	display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
	display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
	justify-content: center;
	-webkit-justify-content: center;
	align-items: center;
	-webkit-align-items: center;
}

.choose-detail-item {
	display: inline-block;
	-webkit-box-flex: 1; /* OLD - iOS 6-, Safari 3.1-6 */
	-webkit-flex: 1; /* Chrome */
	-moz-box-flex: 1; /* OLD - Firefox 19- */
	flex: 1; /* NEW, Spec - Opera 12.1, Firefox 20+ */
	height: 100%;
	width: px2rem(250px);
	border-top: px2rem(6px) solid #ffffff;
}

.choose-detail-item.active {
	border-top-color: $orange;
	background-image: linear-gradient(-180deg, #fff6f4 0%, #fff 50%);
	.selected-text {
		color: $orange;
	}
}

.choose-detail {
	display: inline-block;
	margin: px2rem(37px) 0 0;
	width: 100%;
	height: px2rem(90px);
	text-align: center;
	border-right: 1px #f3f3f3 solid;
	.select-tip {
		margin-top: px2rem(10px);
	}
}

.choose-detail-item:last-child > .choose-detail {
	border-right: none;
}

.popup-box {
	height: px2rem(740px);
	background: #ffffff;
}

.popup-top {
	height: px2rem(164px);
	.user-choose {
		height: 100%;
	}
}
</style>


// WEBPACK FOOTER //
// index.vue?2e4420d4